const hi = {
  nav: {
    home: "होम",
    salons: "सैलून",
    membership: "मेंबरशिप",
    shop: "शॉप",
    academy: "अकादमी",
    blog: "जर्नल",
    login: "लॉगिन",
    logout: "लॉग आउट",
    dashboard: "डैशबोर्ड",
    bookings: "मेरी बुकिंग",
    loyalty: "लॉयल्टी",
    profile: "प्रोफ़ाइल",
    orders: "मेरे ऑर्डर",
    chat: "बातचीत",
    notifications: "सूचनाएँ",
    partner: "पार्टनर",
    admin: "एडमिन",
    partner_panel: "पार्टनर पैनल",
    admin_panel: "एडमिन पैनल",
    login_register: "लॉगिन / रजिस्टर",
    skip_to_content: "सामग्री पर जाएँ",
    account_menu: "अकाउंट मेनू",
    primary_nav: "मुख्य",
    mobile_nav: "मोबाइल नेविगेशन",
    ai_advisor: "AI सलाहकार",
    cart: "शॉपिंग कार्ट",
  },
  footer: {
    tagline: "भारत का प्रीमियम सैलून बुकिंग प्लेटफ़ॉर्म — लक्ज़री सौंदर्य अब आपकी उंगलियों पर।",
    company: "कंपनी",
    about: "हमारे बारे में",
    how_it_works: "यह कैसे काम करता है",
    partners: "पार्टनर्स के लिए",
    stylists: "स्टाइलिस्ट्स के लिए",
    careers: "करियर",
    contact: "संपर्क",
    support: "सहायता",
    faq: "सामान्य प्रश्न",
    help: "सहायता केंद्र",
    privacy: "गोपनीयता नीति",
    terms: "सेवा की शर्तें",
    refund: "रिफंड नीति",
    services: "सेवाएँ",
    salons: "सैलून",
    membership: "मेंबरशिप",
    shop: "शॉप",
    academy: "अकादमी",
    connect: "जुड़ें",
    newsletter_title: "हमारे न्यूज़लेटर से जुड़ें",
    newsletter_sub: "सौंदर्य टिप्स, विशेष ऑफ़र, कोई स्पैम नहीं।",
    newsletter_placeholder: "आपका ईमेल",
    newsletter_cta: "सब्सक्राइब करें",
    copyright: "© {{year}} Fayriza. सर्वाधिकार सुरक्षित।",
    made_in: "भारत में निर्मित",
  },
  home: {
    hero_eyebrow: "भारत का प्रीमियम सैलून नेटवर्क",
    hero_title: "अपने लिए सही सैलून अनुभव खोजें",
    hero_subtitle: "अपने नज़दीकी टॉप-रेटेड सैलून में अपॉइंटमेंट बुक करें — लक्ज़री, सुविधा और देखभाल।",
    search_placeholder: "सैलून, सेवाएँ या स्टाइलिस्ट खोजें…",
    search_cta: "सैलून ढूँढें",
    featured_salons: "फ़ीचर्ड सैलून",
    browse_all: "सभी देखें",
    view_all: "सभी देखें",
    categories_title: "श्रेणियाँ एक्सप्लोर करें",
    categories_sub: "हर अवसर के लिए चुनिंदा सेवाएँ",
    why_title: "Fayriza क्यों",
    why_sub: "शुरू से अंत तक एक प्रीमियम अनुभव",
    why_1_title: "वेरिफाइड सैलून",
    why_1_body: "हर पार्टनर सैलून को सावधानी से चुना और जाँचा जाता है।",
    why_2_title: "इंस्टेंट बुकिंग",
    why_2_body: "रियल-टाइम उपलब्धता, सेकंडों में पुष्टि।",
    why_3_title: "सुरक्षित भुगतान",
    why_3_body: "Razorpay समर्थित, रिफंड-सुरक्षित लेन-देन।",
    why_4_title: "लॉयल्टी और रिवार्ड्स",
    why_4_body: "हर विज़िट पर पॉइंट्स कमाएँ, फ़ायदों के लिए रिडीम करें।",
    testimonials_title: "हमारे समुदाय का प्यार",
    cta_title: "चमकने के लिए तैयार हैं?",
    cta_sub: "हज़ारों Fayriza सदस्यों से जुड़ें।",
    cta_btn: "शुरू करें",
  },
  salons: {
    title: "सभी सैलून",
    subtitle: "अपने नज़दीकी प्रीमियम पार्टनर सैलून ब्राउज़ करें",
    filter: "फ़िल्टर",
    sort: "क्रमबद्ध करें",
    sort_relevance: "प्रासंगिकता",
    sort_rating: "सबसे अधिक रेटेड",
    sort_price_asc: "कीमत: कम से अधिक",
    sort_price_desc: "कीमत: अधिक से कम",
    sort_nearest: "निकटतम",
    search_placeholder: "नाम या क्षेत्र से खोजें…",
    categories_all: "सभी",
    city_all: "सभी शहर",
    price_range: "मूल्य सीमा",
    open_now: "अभी खुला है",
    no_results_title: "आपके फ़िल्टर से कोई सैलून मेल नहीं खाता",
    no_results_sub: "कोई फ़िल्टर हटाकर या कोई दूसरा क्षेत्र खोजकर देखें।",
    clear_filters: "फ़िल्टर हटाएँ",
    showing: "{{count}} सैलून दिखाए जा रहे हैं",
    loading: "सैलून लोड हो रहे हैं…",
    book_now: "अभी बुक करें",
    from: "से शुरू",
    per_service: "प्रति सेवा",
    results: "परिणाम",
    filters_title: "फ़िल्टर",
    reset_all: "सभी रीसेट करें",
    category: "श्रेणी",
    min_rating: "न्यूनतम रेटिंग",
    any_rating: "कोई भी रेटिंग",
    for_gender: "के लिए",
    gender_women: "महिलाएं",
    gender_men: "पुरुष",
    gender_unisex: "यूनिसेक्स",
    cat_bridal: "दुल्हन",
    cat_spa: "स्पा",
  },
  salon: {
    book_now: "अभी बुक करें",
    message: "संदेश",
    favourite: "पसंदीदा",
    unfavourite: "पसंदीदा से हटाएँ",
    share: "शेयर करें",
    directions: "दिशा-निर्देश",
    call: "कॉल करें",
    services: "सेवाएँ",
    stylists: "स्टाइलिस्ट्स",
    reviews: "समीक्षाएँ",
    availability: "उपलब्धता",
    gallery: "गैलरी",
    about: "परिचय",
    working_hours: "कार्य समय",
    amenities: "सुविधाएँ",
    contact: "संपर्क",
    overview: "अवलोकन",
    location: "स्थान",
    reviews_count: "{{count}} समीक्षाएँ",
    rating_out_of: "5 में से {{rating}}",
    select_service: "बुक करने के लिए सेवा चुनें",
    duration: "अवधि",
    minutes: "{{min}} मिनट",
    open: "खुला",
    closed: "बंद",
    closes_at: "{{time}} पर बंद होगा",
    opens_at: "{{time}} पर खुलेगा",
  },
  booking: {
    title: "अपॉइंटमेंट बुक करें",
    step_services: "सेवाएँ",
    step_stylist: "स्टाइलिस्ट",
    step_datetime: "तारीख़ और समय",
    step_review: "समीक्षा",
    step_pay: "भुगतान",
    select_services: "सेवाएँ चुनें",
    select_stylist: "स्टाइलिस्ट चुनें",
    any_stylist: "कोई भी उपलब्ध स्टाइलिस्ट",
    select_date: "तारीख़ चुनें",
    select_time: "समय चुनें",
    no_slots: "इस तारीख़ पर कोई स्लॉट उपलब्ध नहीं",
    try_other_date: "कोई दूसरी तारीख़ आज़माएँ",
    confirm: "बुकिंग पक्की करें",
    cancel: "बुकिंग रद्द करें",
    reschedule: "पुनर्निर्धारित करें",
    subtotal: "उप-कुल",
    discount: "छूट",
    tax: "कर और शुल्क",
    total: "कुल",
    pay_now: "अभी भुगतान करें",
    pay_at_salon: "सैलून में भुगतान करें",
    use_wallet: "वॉलेट का उपयोग करें",
    apply_offer: "ऑफ़र लागू करें",
    offer_placeholder: "कोड डालें",
    apply: "लागू करें",
    remove: "हटाएँ",
    booking_confirmed: "बुकिंग पक्की हो गई!",
    booking_cancelled: "बुकिंग रद्द हो गई",
    booking_ref: "बुकिंग आईडी",
    when: "कब",
    where: "कहाँ",
    who: "के साथ",
    notes: "नोट जोड़ें (वैकल्पिक)",
    notes_placeholder: "एलर्जी, प्राथमिकताएँ…",
    upcoming: "आगामी",
    past: "पिछले",
    cancelled: "रद्द",
    view_details: "विवरण देखें",
    download_receipt: "रसीद डाउनलोड करें",
    rate_visit: "इस विज़िट को रेट करें",
  },
  auth: {
    login_title: "वापस स्वागत है",
    login_sub: "Fayriza पर जारी रखने के लिए साइन इन करें",
    register_title: "अकाउंट बनाएँ",
    register_sub: "भारत के प्रीमियम सैलून नेटवर्क से जुड़ें",
    email: "ईमेल",
    email_placeholder: "you@example.com",
    password: "पासवर्ड",
    password_placeholder: "कम से कम 8 अक्षर",
    phone: "फ़ोन नंबर",
    phone_placeholder: "10-अंकों का मोबाइल नंबर",
    name: "पूरा नाम",
    name_placeholder: "आपका नाम",
    otp: "OTP दर्ज करें",
    otp_placeholder: "6-अंकों का कोड",
    send_otp: "OTP भेजें",
    verify_otp: "सत्यापित करें",
    resend_otp: "OTP दोबारा भेजें",
    resend_in: "{{s}} सेकंड में दोबारा भेजें",
    login_cta: "साइन इन करें",
    register_cta: "अकाउंट बनाएँ",
    forgot_password: "पासवर्ड भूल गए?",
    reset_password: "पासवर्ड रीसेट करें",
    reset_sub: "अपना ईमेल दर्ज करें, हम रीसेट लिंक भेजेंगे",
    reset_sent: "रीसेट लिंक आपके ईमेल पर भेज दिया गया है",
    new_password: "नया पासवर्ड",
    confirm_password: "पासवर्ड पक्का करें",
    social_login: "या इनके साथ जारी रखें",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ईमेल सत्यापित करें",
    verify_email_sub: "हमने {{email}} पर सत्यापन लिंक भेजा है",
    resend_email: "सत्यापन ईमेल दोबारा भेजें",
    accept_terms: "मैं शर्तों और गोपनीयता नीति से सहमत हूँ",
    switch_to_register: "अकाउंट नहीं है?",
    switch_to_register_cta: "साइन अप करें",
    switch_to_login: "पहले से अकाउंट है?",
    switch_to_login_cta: "साइन इन करें",
    remember_me: "मुझे याद रखें",
    phone_or_email: "फ़ोन या ईमेल",
    use_phone: "इसके बजाय फ़ोन का उपयोग करें",
    use_email: "इसके बजाय ईमेल का उपयोग करें",
  },
  profile: {
    title: "मेरी प्रोफ़ाइल",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    change_password: "पासवर्ड बदलें",
    avatar: "प्रोफ़ाइल फ़ोटो",
    upload_photo: "फ़ोटो अपलोड करें",
    name: "पूरा नाम",
    phone: "फ़ोन नंबर",
    email: "ईमेल",
    dob: "जन्म तिथि",
    gender: "लिंग",
    gender_male: "पुरुष",
    gender_female: "महिला",
    gender_other: "अन्य",
    address: "पता",
    city: "शहर",
    pincode: "पिनकोड",
    save: "परिवर्तन सहेजें",
    saved: "प्रोफ़ाइल अपडेट हो गई",
    current_password: "मौजूदा पासवर्ड",
    current_password_placeholder: "मौजूदा पासवर्ड दर्ज करें",
    new_password: "नया पासवर्ड",
    new_password_placeholder: "कम से कम 8 अक्षर",
    password_changed: "पासवर्ड सफलतापूर्वक बदल दिया गया",
  },
  dashboard: {
    title: "डैशबोर्ड",
    welcome: "वापस स्वागत है, {{name}}",
    upcoming_bookings: "आगामी बुकिंग",
    no_upcoming: "कोई आगामी अपॉइंटमेंट नहीं",
    book_a_salon: "सैलून बुक करें",
    favourites: "पसंदीदा सैलून",
    no_favourites: "आपने अब तक कोई सैलून पसंदीदा नहीं बनाया है",
    loyalty_points: "लॉयल्टी पॉइंट्स",
    wallet_balance: "वॉलेट बैलेंस",
    recent_activity: "हालिया गतिविधि",
    quick_actions: "त्वरित कार्य",
    view_all: "सभी देखें",
    manage_membership: "मेंबरशिप प्रबंधित करें",
    top_up_wallet: "वॉलेट टॉप अप करें",
    refer_friend: "दोस्त को रेफ़र करें",
  },
  common: {
    loading: "लोड हो रहा है…",
    error: "कुछ गड़बड़ हो गई",
    retry: "दोबारा कोशिश करें",
    no_results: "कोई परिणाम नहीं मिला",
    search: "खोजें",
    filter: "फ़िल्टर",
    sort: "क्रमबद्ध करें",
    view_all: "सभी देखें",
    see_more: "और देखें",
    see_less: "कम देखें",
    back: "वापस",
    next: "आगे",
    previous: "पिछला",
    submit: "सबमिट करें",
    cancel: "रद्द करें",
    delete: "हटाएँ",
    edit: "संपादित करें",
    save: "सहेजें",
    close: "बंद करें",
    confirm: "पक्का करें",
    continue: "जारी रखें",
    yes: "हाँ",
    no: "नहीं",
    skip: "छोड़ें",
    optional: "वैकल्पिक",
    required: "आवश्यक",
    from: "से",
    per: "प्रति",
    to: "तक",
    and: "और",
    or: "या",
    learn_more: "और जानें",
    coming_soon: "जल्द आ रहा है",
    currency: "₹",
    minutes_short: "मिनट",
    hours_short: "घंटा",
    km: "कि.मी.",
    away: "दूर",
    stars: "स्टार",
  },
  loyalty: {
    title: "Fayriza लॉयल्टी",
    subtitle: "हर विज़िट पर पॉइंट्स कमाएँ, इनामों के लिए रिडीम करें",
    points: "पॉइंट्स",
    available_points: "उपलब्ध पॉइंट्स",
    total_earned: "कुल अर्जित",
    total_redeemed: "कुल रिडीम",
    redeem: "रिडीम करें",
    history: "पॉइंट्स इतिहास",
    rewards: "रिवार्ड्स",
    tier: "टियर",
    how_it_works: "यह कैसे काम करता है",
    earn_title: "कमाएँ",
    earn_body: "हर ₹10 खर्च पर 1 पॉइंट। Gold पर 2×, Platinum पर 3×।",
    redeem_title: "रिडीम करें",
    redeem_body: "पॉइंट्स का उपयोग वॉलेट क्रेडिट, फ़्री सेवाओं या पार्टनर फ़ायदों के लिए करें।",
    empty_history: "अब तक कोई पॉइंट्स गतिविधि नहीं",
    empty_rewards: "अभी कोई रिवार्ड उपलब्ध नहीं",
  },
  wallet: {
    title: "Fayriza वॉलेट",
    subtitle: "एक बार टॉप अप करें, बेफ़िक्र बुक करें",
    balance: "बैलेंस",
    available: "उपलब्ध",
    topup: "टॉप अप",
    topup_cta: "पैसे जोड़ें",
    topup_amount: "राशि",
    history: "लेन-देन इतिहास",
    empty_history: "अब तक कोई लेन-देन नहीं",
    credit: "क्रेडिट",
    debit: "डेबिट",
    refund: "रिफंड",
  },
  membership: {
    eyebrow: "विशेष एक्सेस",
    hero_title: "Fayriza मेंबरशिप प्लान",
    hero_sub: "भारत के 500+ प्रीमियम सैलून में विशेष छूट, प्राथमिक बुकिंग और लक्ज़री फ़ायदे पाएँ।",
    plans: "मेंबरशिप प्लान",
    subscribe: "सब्सक्राइब करें",
    cancel: "मेंबरशिप रद्द करें",
    current: "मौजूदा प्लान",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/वर्ष",
    per_month_approx: "≈ ₹{{amount}}/माह",
    cancel_anytime: "कभी भी रद्द करें",
    choose_title: "अपना प्लान चुनें",
    choose_sub: "सभी प्लान सालाना बिल होते हैं। प्लान चुनें और तुरंत सक्रिय करने के लिए पुष्टि करें।",
    most_popular: "सबसे लोकप्रिय",
    get_plan: "{{plan}} लें",
    selected_proceed: "चुना गया — भुगतान पर जाएँ →",
    processing: "प्रोसेस हो रहा है…",
    current_plan_label: "✓ मौजूदा प्लान",
    welcome_back: "वापस स्वागत है, {{name}}!",
    member_label: "Fayriza {{tier}} सदस्य",
    expires_in: "{{days}} दिनों में समाप्त होगा",
    renews_on: "{{date}} को नवीनीकृत होगा",
    your_discount: "आपकी छूट",
    off_all: "सभी सेवाओं पर",
    expiring_warn: "आपकी मेंबरशिप जल्द समाप्त हो रही है। छूट बनाए रखने के लिए अभी नवीनीकरण करें।",
    feature_comparison: "पूरी फ़ीचर तुलना",
    feature: "फ़ीचर",
    benefits_500: "500+ पार्टनर सैलून",
    benefits_instant: "तुरंत सक्रियण",
    benefits_cancel: "कभी भी रद्द करें",
    benefits_refund: "7-दिन मनी बैक",
    faq_title: "अक्सर पूछे जाने वाले प्रश्न",
    faq_cancel_q: "क्या मैं अपनी मेंबरशिप रद्द कर सकता हूँ?",
    faq_cancel_a: "हाँ। आप अपने डैशबोर्ड से कभी भी रद्द कर सकते हैं। आपके फ़ायदे बिलिंग अवधि के अंत तक जारी रहेंगे।",
    faq_all_salons_q: "क्या छूट सभी सैलून पर लागू होती है?",
    faq_all_salons_a: "हाँ — भारत भर में 500+ वेरिफाइड Fayriza पार्टनर सैलून पर छूट स्वतः लागू होती है।",
    faq_refund_q: "7-दिन मनी बैक गारंटी क्या है?",
    faq_refund_a: "अगर आप सक्रियण के 7 दिनों के भीतर संतुष्ट नहीं हैं, तो हम आपकी पूरी मेंबरशिप फ़ीस वापस करेंगे — बिना कोई सवाल पूछे।",
    faq_upgrade_q: "क्या मैं अपना प्लान अपग्रेड कर सकता हूँ?",
    faq_upgrade_a: "हाँ। आप कभी भी अपग्रेड कर सकते हैं। बची अवधि के लिए आनुपातिक अंतर लिया जाएगा।",
    activated: "🎉 Fayriza {{plan}} सक्रिय हो गया!",
    subscribe_failed: "सब्सक्रिप्शन विफल। कृपया दोबारा कोशिश करें।",
  },
  shop: {
    eyebrow: "Fayriza शॉप",
    hero_title: "प्रीमियम सौंदर्य और ग्रूमिंग उत्पाद",
    hero_sub: "चुनिंदा प्रोफ़ेशनल-ग्रेड ज़रूरी सामान, आपके दरवाज़े तक।",
    search_placeholder: "उत्पाद खोजें…",
    categories: "श्रेणियाँ",
    all_products: "सभी उत्पाद",
    add_to_cart: "कार्ट में जोड़ें",
    added: "जोड़ा गया ✓",
    out_of_stock: "स्टॉक में नहीं",
    checkout: "चेकआउट",
    cart: "कार्ट",
    cart_empty: "आपका कार्ट खाली है",
    cart_empty_sub: "इसे भरने के लिए शॉपिंग शुरू करें",
    products: "उत्पाद",
    orders: "मेरे ऑर्डर",
    no_orders: "अब तक कोई ऑर्डर नहीं",
    order_ref: "ऑर्डर आईडी",
    order_status: "स्थिति",
    order_placed: "प्लेस किया गया",
    order_shipped: "शिप किया गया",
    order_delivered: "डिलीवर हो गया",
    order_cancelled: "रद्द",
    qty: "मात्रा",
    remove: "हटाएँ",
    subtotal: "उप-कुल",
    shipping: "शिपिंग",
    tax: "कर",
    total: "कुल",
    proceed_checkout: "चेकआउट पर जाएँ",
    shipping_address: "शिपिंग पता",
    place_order: "ऑर्डर करें",
    continue_shopping: "शॉपिंग जारी रखें",
    product_details: "उत्पाद विवरण",
    description: "विवरण",
    specifications: "विनिर्देश",
    you_may_like: "आपको यह भी पसंद आ सकता है",
    related: "संबंधित उत्पाद",
  },
  academy: {
    eyebrow: "Fayriza अकादमी",
    hero_title: "भारत के श्रेष्ठ स्टाइलिस्ट्स से सीखें",
    hero_sub: "प्रमाणित विशेषज्ञों द्वारा सिखाए गए प्रोफ़ेशनल सौंदर्य और ग्रूमिंग कोर्स। अपनी गति से सीखें, सर्टिफ़िकेट पाएँ और अपना करियर शुरू करें।",
    search_placeholder: "कोर्स या इंस्ट्रक्टर खोजें…",
    stats_courses: "विशेषज्ञ कोर्स",
    stats_students: "नामांकित छात्र",
    stats_rating: "औसत रेटिंग",
    stats_certificate: "सर्टिफ़िकेट शामिल",
    all: "सभी कोर्स",
    makeup: "मेकअप",
    hair: "बाल",
    skin: "त्वचा",
    nails: "नाखून",
    grooming: "ग्रूमिंग",
    courses: "कोर्स",
    course: "कोर्स",
    enroll: "अभी नामांकन करें",
    enrolled: "नामांकित",
    modules: "मॉड्यूल",
    instructor: "इंस्ट्रक्टर",
    duration: "अवधि",
    level: "स्तर",
    level_beginner: "शुरुआती",
    level_intermediate: "मध्यम",
    level_advanced: "उन्नत",
    certificate: "सर्टिफ़िकेट",
    no_courses: "आपके फ़िल्टर से कोई कोर्स मेल नहीं खाता",
    my_enrollments: "मेरे कोर्स",
    continue_learning: "सीखना जारी रखें",
    completed: "पूरा हुआ",
  },
  notifications: {
    title: "सूचनाएँ",
    empty: "आप पूरी तरह अपडेटेड हैं",
    empty_sub: "अभी कोई नई सूचना नहीं",
    mark_all_read: "सभी को पढ़ा हुआ मार्क करें",
    just_now: "अभी-अभी",
    minutes_ago: "{{n}} मिनट पहले",
    hours_ago: "{{n}} घंटे पहले",
    days_ago: "{{n}} दिन पहले",
  },
  ai: {
    title: "Fayriza AI सलाहकार",
    subtitle: "AI द्वारा संचालित, आपके लिए व्यक्तिगत सौंदर्य सिफ़ारिशें।",
    placeholder: "त्वचा, बाल, मेकअप के बारे में कुछ भी पूछें…",
    send: "भेजें",
    examples_title: "यह पूछकर देखें",
    ex_1: "मेरे चेहरे के आकार के लिए सबसे अच्छा हेयरकट?",
    ex_2: "तैलीय त्वचा के लिए स्किनकेयर रूटीन",
    ex_3: "2026 के ब्राइडल मेकअप ट्रेंड्स",
    thinking: "सोच रहा है…",
    disclaimer: "सुझाव केवल जानकारी के लिए हैं। चिकित्सा संबंधी चिंताओं के लिए विशेषज्ञ से सलाह लें।",
  },
  marketing: {
    about: {
      eyebrow: "हमारी कहानी",
      title: "सौंदर्य, नए अंदाज़ में",
      sub: "Fayriza एक साधारण सोच से शुरू हुआ — भारत को उसकी कला जितना ही परिष्कृत सैलून बुकिंग अनुभव मिलना चाहिए।",
      mission_title: "हमारा मिशन",
      mission_body: "एक सहज, भरोसेमंद और शानदार प्लेटफ़ॉर्म के ज़रिए लाखों सौंदर्य प्रेमियों को भारत के बेहतरीन सैलून से जोड़ना।",
      vision_title: "हमारा विज़न",
      vision_body: "एक ऐसी दुनिया जहाँ हर किसी के पास गुणवत्तापूर्ण सौंदर्य और वेलनेस सेवाओं की उंगलियों पर पहुँच हो।",
      values_title: "हमारे मूल्य",
      value_1_title: "गुणवत्ता सबसे पहले",
      value_1_body: "हर पार्टनर सैलून वेरिफ़ाइड है और हमारे प्रीमियम मानकों पर खरा उतरता है।",
      value_2_title: "ग्राहक पर केंद्रित",
      value_2_body: "आपका अनुभव हमारा मार्गदर्शक है — बुकिंग से लेकर आफ़्टरकेयर तक।",
      value_3_title: "पार्टनर्स को सशक्त बनाना",
      value_3_body: "जब हमारे सैलून और स्टाइलिस्ट बढ़ते हैं, तब हम बढ़ते हैं।",
      cta_title: "इस कहानी का हिस्सा बनें",
      cta_sub: "आज ही Fayriza समुदाय से जुड़ें।",
    },
    how_it_works: {
      eyebrow: "यह कैसे काम करता है",
      title: "तीन चरणों में बुक करें",
      sub: "बिना अनुमान के प्रीमियम सौंदर्य।",
      step_1_title: "खोजें",
      step_1_body: "अपने पास के वेरिफ़ाइड सैलून, सेवाएँ और स्टाइलिस्ट ब्राउज़ करें।",
      step_2_title: "बुक करें",
      step_2_body: "अपनी पसंद का समय चुनें — तुरंत पुष्टि।",
      step_3_title: "आनंद लें",
      step_3_body: "खुद को पैंपर करें। विज़िट को रेट करें। रिवार्ड्स कमाएँ।",
      faq_title: "जल्दी सवाल",
    },
    partners: {
      eyebrow: "सैलून मालिकों के लिए",
      title: "Fayriza के साथ बढ़ें",
      sub: "नए ग्राहक पाएँ, खाली कुर्सियाँ भरें और आधुनिक सैलून चलाएँ।",
      benefit_1_title: "ज़्यादा ग्राहक",
      benefit_1_body: "भारत के सबसे बड़े प्रीमियम सौंदर्य दर्शकों तक पहुँच।",
      benefit_2_title: "स्मार्ट बुकिंग",
      benefit_2_body: "एक ही डैशबोर्ड से शेड्यूल, स्टाफ़ और सेवाएँ प्रबंधित करें।",
      benefit_3_title: "तुरंत भुगतान",
      benefit_3_body: "सुरक्षित, तेज़ पेआउट — कोई मैनुअल पीछा नहीं।",
      cta: "पार्टनर बनें",
    },
    stylists: {
      eyebrow: "स्टाइलिस्ट्स के लिए",
      title: "अपनी ग्राहकी बनाएँ",
      sub: "अपना काम दिखाएँ, पहचान पाएँ और करियर आगे बढ़ाएँ।",
      cta: "स्टाइलिस्ट के रूप में आवेदन करें",
    },
    careers: {
      eyebrow: "करियर",
      title: "सौंदर्य का भविष्य गढ़ें",
      sub: "हम एक छोटी टीम हैं जो कुछ बड़ा बना रही है। जुड़ना चाहेंगे?",
      openings_title: "खुले पद",
      no_openings: "अभी कोई पद खुला नहीं है। careers@fayriza.com पर हमें लिखें।",
    },
    contact: {
      eyebrow: "संपर्क करें",
      title: "हमें आपसे सुनना अच्छा लगेगा",
      sub: "सवाल, फ़ीडबैक या पार्टनरशिप के विचार — हम सब सुनने को तैयार हैं।",
      name: "आपका नाम",
      email: "आपका ईमेल",
      message: "संदेश",
      send: "संदेश भेजें",
      sent: "धन्यवाद — हम 24 घंटों के भीतर जवाब देंगे।",
      support_email: "सहायता",
      partners_email: "पार्टनर्स",
      media_email: "मीडिया",
    },
    faq: {
      eyebrow: "सहायता",
      title: "अक्सर पूछे जाने वाले प्रश्न",
      sub: "सामान्य सवालों के तेज़ जवाब।",
    },
    legal: {
      privacy_title: "गोपनीयता नीति",
      terms_title: "सेवा की शर्तें",
      refund_title: "रिफंड नीति",
      last_updated: "अंतिम अपडेट {{date}}",
    },
  },
  errors: {
    network: "नेटवर्क एरर — अपना कनेक्शन जाँचें",
    unauthorised: "जारी रखने के लिए कृपया साइन इन करें",
    forbidden: "आपके पास इसका एक्सेस नहीं है",
    not_found: "आप जो खोज रहे हैं वह हमें नहीं मिला",
    server: "सर्वर एरर — कृपया बाद में कोशिश करें",
    validation: "कृपया हाइलाइट किए गए फ़ील्ड जाँचें",
    generic: "कुछ गड़बड़ हो गई",
    page_not_found_title: "पेज नहीं मिला",
    page_not_found_sub: "जो पेज आप खोज रहे हैं वह हट गया है या अब मौजूद नहीं है।",
    go_home: "होम पर जाएँ",
  },
};

export default hi;
